import * as React from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton } from 'ui_kit_qmd'
import { HeaderView } from '../header-view/HeaderView'
import { useProductOrderContext } from '../../context'
import '../product-selection-view/productSelectionView.scss'
import { OptionTile } from '../product-selection-view/components/option-tile/OptionTile'

export const MoudCombinedProductsView = () => {
  const { selectedOption, productList, setProduct, goForward, updateCart } = useProductOrderContext()

  const all = React.useMemo(() => {
    // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
    const products = productList.flatMap((item) => item.Products)
    const options = products.flatMap((product) => product.Options)
    return { options, products }
  }, [productList])

  React.useEffect(() => {
    if (selectedOption) {
      const selectedProduct = all.products.find((x) => x.Options.some((y) => y.OptionId === selectedOption.OptionId))
      setProduct(selectedProduct)
    }
  }, [all.products, selectedOption, setProduct])

  return (
    <div className='product-selection-view-container'>
      <HeaderView title='New OUD Order' />
      <div className='product-selection-view-body-container'>
        <div className='product-selection-view-text-container'>
          All prices shown do not yet reflect any visit or accounts credits, which will be applied prior to payment.
        </div>

        <div className='product-selection-view-text-container'>Please select a Bup/Nx form and dosage:</div>

        <div className='product-selection-view-doses-container-vertical-flow'>
          {all.options.map((option) => (
            <OptionTile key={option.OptionId} option={option} />
          ))}
        </div>
      </div>

      <div className='product-selection-view-button-container'>
        <PrimaryButton
          useUpdatedStyle
          disabled={selectedOption === undefined}
          btnText='Select'
          onPress={() => {
            const selectedProduct = all.products.find((x) =>
              // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
              x.Options.some((y) => y.OptionId === selectedOption.OptionId),
            )

            // Pass selectedProduct directly to updateCart — the context's
            // `product` state is set asynchronously by our useEffect above, so
            // relying on `currentProduct || product` inside updateCart races
            // with the click and crashed reading `productItem.FulfillmentType`
            // when product was still null from a prior goBack/onAddMoreScripts.
            if (selectedOption && selectedProduct) {
              updateCart(undefined, undefined, selectedProduct)
              goForward()
            }
          }}
        />
      </div>
    </div>
  )
}
